import { Box } from "@mui/material";

export default function Dashboard() {
  return <Box>dashboard</Box>;
}
